import { BorderColor, Delete } from '@mui/icons-material'
import { Card, CardActions, CardContent, CardHeader, Divider, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { t } from 'i18next'
import TargetType from '../../../store/types/enums/TargetType'
import CustomComment from '../../../store/types/models/CustomComment'
import { formatStringDate } from '../../../store/utils/dateUtils'
import { SquareButton } from '../../../styles/ButtonStyles'
import AvatarComponent from '../../avatar/AvatarComponent'
import LikeDislikeCommentSection from '../../LikeDislike/LikeDislikeCommentSection'

type CommentCardProps = {
  comment: CustomComment
  handleEdit: () => void
  currentUserId: string | undefined
  handleDelete: () => void
}

const CommentCard = ({ comment, handleEdit, currentUserId, handleDelete }: CommentCardProps) => {
  const userCommenting = comment.author
  return (
    <Card elevation={4} sx={{ flexShrink: 0 }}>
      <CardHeader
        sx={{ pt: 1 }}
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AvatarComponent
                avatar={userCommenting.avatar}
                extension={userCommenting.extension}
                alt={userCommenting.firstName + ' ' + userCommenting.lastName}
                size={32}
              />
              <Box>
                <Typography
                  component={'h2'}
                  variant={'h6'}
                  lineHeight={1.43}
                >{`${userCommenting.firstName} ${userCommenting.lastName}`}</Typography>
                {!comment.edited ? (
                  <Typography variant={'body2'}>{formatStringDate(comment.createdAt, true)}</Typography>
                ) : (
                  <Box display="flex" alignItems="center">
                    <Typography variant="body2">{formatStringDate(comment.editedAt ?? '', true)}</Typography>
                    <Typography variant="caption" sx={{ marginLeft: 0.5 }}>
                      ({t('components.commentsSidebar.edited')})
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            {currentUserId === userCommenting.id && (
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Tooltip title={t('components.commentsSidebar.editComment')}>
                  <SquareButton color={'secondary'} onClick={handleEdit}>
                    <BorderColor />
                  </SquareButton>
                </Tooltip>
                <Tooltip title={t('components.commentsSidebar.deleteComment')}>
                  <SquareButton color={'secondary'} onClick={handleDelete}>
                    <Delete />
                  </SquareButton>
                </Tooltip>
              </Box>
            )}
          </Box>
        }
      />
      <CardContent sx={{ wordBreak: 'break-word' }}>{comment.content}</CardContent>
      <Divider />
      <CardActions sx={{ px: 2 }}>
        <LikeDislikeCommentSection
          targetId={comment.id}
          targetType={TargetType.COMMENT}
          withoutComments
          upVoters={comment.upVoters}
          downVoters={comment.downVoters}
        />
      </CardActions>
    </Card>
  )
}

export default CommentCard
